import { createPinia } from 'pinia'

const store = createPinia()

export default store

export * from './user'
export * from './auth'
export * from './merchant'